/**
 * Turn selected reports into POST /reports bodies that log the same chapters
 * for another reader. One body per read date (and note), so each copy keeps
 * the day it was read. Reports already on that reader are skipped.
 */
export function buildCopyRequests(reports, targetReaderId) {
  const groups = new Map();
  let skipped = 0;

  for (const report of reports) {
    if (report.readerId === targetReaderId || report.reader?.id === targetReaderId) {
      skipped += 1;
      continue;
    }
    const notes = report.notes || '';
    const key = `${report.readDate}\u0000${notes}`;
    if (!groups.has(key)) {
      groups.set(key, {
        readerIds: [targetReaderId],
        chapterIds: [],
        readDate: report.readDate,
        ...(notes ? { notes } : {})
      });
    }
    groups.get(key).chapterIds.push(report.chapterId);
  }

  return { requests: [...groups.values()], skipped };
}
